import React from 'react'
import { withRouter } from 'react-router-dom'

const NotFound = () => {
  return <div>PAGE NOT FOUND</div>
}

export default withRouter(NotFound)
